import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";

const formatDateTime = (iso) => {
  if (!iso) return "—";

  const d = new Date(iso);

  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const EditCashLedgerModal = ({
  show,
  onClose,
  data,
  onSubmit,
  loading = false,
}) => {
  const [amount, setAmount] = useState("");

  useEffect(() => {
    if (data?.amount !== undefined) {
      setAmount(data.amount);
    }
  }, [data]);

  const handleSubmit = () => {
    onSubmit?.({
      ...data,
      amount: Number(amount),
    });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton className="border-bottom">
        <Modal.Title className="d-flex align-items-center gap-2 fw-bold">
          <Icon icon="tabler:edit" className="text-xl" />
          Edit Cash Ledger
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <div className="row g-4">
          {/* Name */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Name</label>
            <input
              type="text"
              className="form-control"
              value={data?.name || ""}
              disabled
            />
          </div>

          {/* Type */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Type</label>
            <input
              type="text"
              className="form-control text-capitalize"
              value={data?.type || ""}
              disabled
            />
          </div>

          {/* Amount Editable */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">
              Amount (₹)
            </label>

            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
            />
          </div>

          {/* Date */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">Date</label>

            <input
              type="text"
              className="form-control"
              value={formatDateTime(data?.date)}
              disabled
            />
          </div>

          {/* Remark */}
          <div className="col-md-12">
            <label className="form-label fw-semibold">Remark</label>

            <textarea
              rows={3}
              className="form-control"
              value={data?.remark || "—"}
              disabled
            />
          </div>

        </div>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button
          variant="light"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Ledger"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditCashLedgerModal;